import React from 'react';
import './footer.css'; // You can create a CSS file for styling 
import { AiFillFacebook, AiFillGithub, AiFillInstagram, AiFillLinkedin } from 'react-icons/ai';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'   

function Footer() {
  return (
    <div className="footer">
      <h2 className="heading">Connect with me!</h2>
      <p className="para">Connect to all my socials, support us and help us grow!</p>
      <div className='footerIconsDiv'>
        <a className='iconsUl' href="https://github.com/faisal-murad" target="_blank" rel="noopener noreferrer"><AiFillGithub style={{ height: 35, width: 35 }} /></a>
        <a className='iconsUl' href="https://www.linkedin.com/in/faisalmurad01/" target="_blank" rel="noopener noreferrer"><AiFillLinkedin style={{ height: 35, width: 35 }} /></a>
        <a className='iconsUl' href="https://www.instagram.com/faisalm0rad/" target="_blank" rel="noopener noreferrer"><AiFillInstagram style={{ height: 35, width: 35 }} /></a>
        <a className='iconsUl' href="https://web.facebook.com/profile.php?id=100031033301734/" target="_blank" rel="noopener noreferrer"><AiFillFacebook style={{ height: 35, width: 35 }} /></a>

      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection:'column' }}>

        <div style={{ width: '95%', height: '2px', backgroundColor: 'grey' }} >
        </div>
        <div className='mainDivCopyright' style={{height:'10vh', width:'100%',display:'flex'}}>
          <div style={{width:'50%', display:"flex", justifyContent:'center', alignItems:'flex-start'}}>
          <p className='textCopyright'>Developed by Faisal Murad</p>
            
          </div> 
          <div style={{width:'50%', display:'flex', justifyContent:'center', alignItems:'center'}}>
          <p className='textCopyright'> &copy;2024 Faisal Murad | All rights reserved</p>
            
          </div>

        </div>
      </div>
      {/* <div className="footer-items">  
        <div style={{backgroundColor:'red', width:'100%', height:'100%'}}>
          
        </div>
      </div> */}
    </div>
  );
}

export default Footer;